import Form from "@/shared/form/form";
import { FieldsType } from "../model/types";
import Input from "@/shared/form/input";
import { SubmitButton } from "@/shared/form/button";
import { useFeedback } from "../model/use-feedback";
import { useTranslations } from "use-intl";
import { ScreenshotButton } from "./screenshot-button";
import { UploadInput } from "./upload-input";

export function UserFeedbackForm({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const t = useTranslations("Feedback");

  const [form] = Form.useForm();
  const { send } = useFeedback({ afterSubmit });

  return (
    <Form form={form} layout="vertical" onFinish={send}>
      <Form.Item<FieldsType>
        name="message"
        label={t("FEEDBACK_FORM_DESCRIPTION_LABEL")}
        rules={[{ required: true }]}
      >
        <Input.TextArea
          placeholder={t("FEEDBACK_FORM_DESCRIPTION_PLACEHOLDER")}
          rows={5}
        />
      </Form.Item>

      <Form.Item<FieldsType> name="attachments">
        <UploadInput name="attachments" />
      </Form.Item>

      <Form.Item<FieldsType> name="screenshot">
        <ScreenshotButton />
      </Form.Item>

      <SubmitButton block />
    </Form>
  );
}
